import { type FunctionComponent } from 'react';
import { type Maybe, type ProductViewEnum } from '../../../__generated__/graphql-client-types';
import { SwatchContextProvider } from '../../../contexts/product-card/swatch.context';
import { mapSearchVariantToProductSwatch } from '../../../helpers/product-helper/product-swatch/product-swatch.helper';
import { useSearchResults } from '../../../hooks/apollo/search/search.hooks';
import { type DropType } from '../../../types/search.types';
import { SearchProductCard } from '../search-product-card/search-product-card.component';
import { SearchProductCardSkeletonList } from '../search-product-card-skeleton/search-product-card-skeleton.component';

export type SearchResultsProps = {
	viewType?: Maybe<ProductViewEnum>;
	dropType?: DropType;
};

export const SearchResults: FunctionComponent<SearchResultsProps> = ({ viewType, dropType }) => {
	const { results, loading, page, isNonstock, isNewLookAndFeelProductCard, createGTMEvent } = useSearchResults();

	return (
		<>
			{results?.products && (
				<div className={`flex ${viewType === 'LIST' ? 'flex-column flex-row-ns' : ''} flex-wrap ml3-l`}>
					{results?.products.map((product, index) => {
						if (product.variants) {
							const initialVariant = product.variants.find((v) => v.id === product.id) ?? product.variants[0];
							return (
								<SwatchContextProvider
									swatch={mapSearchVariantToProductSwatch(initialVariant)}
									key={`${initialVariant.id}-${index}`}>
									<SearchProductCard
										dropType={dropType}
										product={product}
										viewType={viewType}
										cardIndex={index}
										page={page}
										searchId={results.searchId}
										isNonstockSearch={isNonstock}
										isNewLookAndFeel={isNewLookAndFeelProductCard}
										createGTMEvent={createGTMEvent}
									/>
								</SwatchContextProvider>
							);
						}
						return null;
					})}
				</div>
			)}
			{loading && (
				<div className="absolute top-0 w-100 h-100 bg-theme-white-o70 z-1">
					<div className="sticky top-0">
						<SearchProductCardSkeletonList viewType={viewType} />
					</div>
				</div>
			)}
		</>
	);
};
